import React from "react"

const WhoAreWe = () => {
  return (
    <>
      <div className="display">
        <div className="container">
          <div className="inner-display">
            <div className="display-head">
              <h1>Who are we</h1>
            </div>
            <div className="display-content">
              <span>D</span>warf. Incorporation is a organization which is
              operating in the field of Construction, Fabrication, Smart
              Gardens, Smart Library, Smart parking Solutions and various other
              smart city goals. We started our journey in the year 2019 at New
              Delhi with a small team of achievers. People behind Dwarf have
              remarkable experience in Fabrication, Designing, Finance and
              Marketing.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhoAreWe
